import "pages/Homepage/FaqBlock/FaqBlock.scss";
import Illustration from "pages/Homepage/FaqBlock/assets/chess-illustration.svg";
import ParagraphFAQ from "components/ui/Paragraphs/ParagraphFAQ";
import Button from "components/ui/Button/Button";
import { useHistory } from "react-router-dom";

function FaqBlock({ entity }) {
  const history = useHistory();

  const faqQuestions = entity?.field_faqs.field_faq_questions;

  if (!faqQuestions) {
    return null;
  }

  return (
    <div className={ 'faq-block' }>
      <div className={ 'faq-block__questions' }>
        <div className={ 'faq-block__title' }>
          <h2>Veelgestelde vragen</h2>
          <div>Bekijk hier de meest gestelde vragen</div>
        </div>

        <div className={ 'wrapper--margin-small' }>
          <ParagraphFAQ questions={ faqQuestions }/>
        </div>

        <Button variant={ 'secondary' } onClick={ () => history.push('/help') }>
          Bekijk alle veelgestelde vragen
        </Button>
      </div>

      <div className={ 'faq-block__illustration' }>
        <img src={ Illustration } alt={ '' }/>
      </div>
    </div>
  );
}

export default FaqBlock;
